module.exports = __webpack_public_path__ + "static/competition-1-9cf90ff636f20358eb75d7c30fab3a86.svg";